import { AnyAction } from "redux";
import { commonActionKeys } from "../actions/commonActionKeys";
import { Category } from "src/common/types/visit";
import { sortVisitOptions } from "../utilities/visitOptionUtils";

export default function visitCategoriesReducer(state: Category[] = [], action: AnyAction): Category[] {
  switch (action.type) {
    case commonActionKeys.LOAD_VISIT_CATEGORIES_SUCCESS:
      return sortVisitOptions([...action.visitCategories]) as Category[];
    case commonActionKeys.CLEAR_VISIT_CATEGORIES:
      return [];
    default:
      return state;
  }
}
